var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Card from "../Card";
import React from 'react';
import { mq, styled } from "../../utils";
var StyledCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  border: 2px dashed #aaa;\n  box-shadow: none;\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  border: 2px dashed #aaa;\n  box-shadow: none;\n\n  ",
    ";\n"])), mq({
    textAlign: ['left', 'center'],
}));
var InfoBanner = function (_a) {
    var children = _a.children, className = _a.className, title = _a.title;
    return (React.createElement(StyledCard, { "data-component": "InfoBanner", className: className, title: title }, children));
};
export default InfoBanner;
var templateObject_1;
//# sourceMappingURL=InfoBanner.js.map